import produce from 'immer';
import {
    SET_DEALS_ACTIVE,
    SET_CURRENT_DEALS, SET_DEALS_TOGGLE
} from '../actions/constants';

const initialState = {
    modifier: 'listing',
    deals: [],
    activated: [],
    toggling: false,
    prices: null
};

const activateDeals = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_DEALS_ACTIVE:
            state.activated = payload;
            break;

        case SET_CURRENT_DEALS:
            state.deals = payload;
            break;

        case SET_DEALS_TOGGLE:
            state.toggling = payload;
            break;

        // skip default
    }
}, initialState);

export default activateDeals;
